import { TimeField, ruRU } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { getDateWithCorrectTime, setClass } from '@utils';
import React, { FC, useState } from 'react';
import { EditMeetingTimePickerList } from '../calendar/views/editMeeting/components/EditMeetingTimePickerList';
import '../../styles/components/timePicker.scss';

interface DateTimePickerProp {
  value: Date;
  onChange: (newValue: Date) => void;
  readOnly: boolean;
  isBig?: boolean;
  error?: boolean;
}

export const TimePicker: FC<DateTimePickerProp> = ({
  value, onChange, readOnly, error = false, isBig
}) => {
  const [timeOpen, setTimeOpen] = useState(false);

  const switchTimePicker = () =>
    !readOnly && setTimeOpen((prev) => !prev);

  const timePickerClick = (hours: number, minutes: number) => {
    const newValue = new Date(value);
    newValue.setHours(hours, minutes);
    onChange(getDateWithCorrectTime(newValue, hours, minutes));
    switchTimePicker();
  };

  return (
    <div className="time-picker-block">
      <LocalizationProvider 
        dateAdapter={AdapterDateFns}
        localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <TimeField
          format="HH:mm"
          readOnly={readOnly}
          value={value}
          onClick={switchTimePicker}
          onChange={onChange}
          className={setClass('time-picker', isBig && 'big')}
          slotProps={{
            textField: {
              error: error,
            },
          }}
        />
      </LocalizationProvider>
      {timeOpen && (
        <EditMeetingTimePickerList
          left={0}
          top={34}
          time={value}
          onOuterClick={switchTimePicker}
          onClick={timePickerClick}
          isBig={isBig}
        />
      )}
    </div>
  );
};
